(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('luel-navigation-disclosure')) {
    customElements.define('luel-navigation-disclosure', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const details = this.querySelector('details');
        const summary = this.querySelector('summary');
        const close = (restoreFocus = false) => {
          details.open = false;
          if (restoreFocus) summary.focus();
        };
        document.addEventListener('click', event => {
          if (details.open && !this.contains(event.target)) close();
        }, options);
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && details.open) {
            event.preventDefault();
            close(true);
          }
        }, options);
        document.addEventListener('keyup', event => {
          if (event.key === 'Tab' && !this.contains(document.activeElement)) close();
        }, options);
        window.addEventListener('resize', () => {
          if (getComputedStyle(this).display === 'none') close();
        }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
